var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountProfileBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.593 15.7797C5.593 13.5145 7.42929 11.6782 9.69446 11.6782C10.4498 11.6782 9.99579 11.6782 11.0641 11.6782C12.1323 11.6782 11.6602 11.6782 12.4156 11.6782C14.6907 11.6782 16.5351 13.5226 16.5351 15.7977V16.4654H11.0641H5.593V15.7797Z",
    fill: "#FEEE00",
    stroke: "#404554",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.546C12.5108 9.546 13.7355 8.32127 13.7355 6.81048C13.7355 5.29969 12.5108 4.07495 11 4.07495C9.4892 4.07495 8.26447 5.29969 8.26447 6.81048C8.26447 8.32127 9.4892 9.546 11 9.546Z",
    fill: "#FEEE00",
    stroke: "#404554",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 11.075C21.25 16.7359 16.6609 21.325 11 21.325C5.33908 21.325 0.75 16.7359 0.75 11.075C0.75 8.52409 1.68083 6.19254 3.22232 4.39856C5.10327 2.20951 7.88953 0.824951 11 0.824951C16.6609 0.824951 21.25 5.41403 21.25 11.075Z",
    stroke: "#404554",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProfileBlank);
export default __webpack_public_path__ + "static/media/accountProfileBlank.675f5e4a.svg";
export { ForwardRef as ReactComponent };